import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import ReconciliationItemBasicInfoComponent from "./reconciliation-item-basic-info.component";

export const ReconciliationItemPopup = ({ 
  selectedReconciliationItem,
  closeModal,
  handleSaveReconciliationItem,
}: any) => {
  console.log('selectedReconciliationItem', selectedReconciliationItem)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedReconciliationItem));

    const handleLocalFormChange = ({path, value}: any) => {
      console.log('selectedReconciliationItem, path, value', selectedReconciliationItem, path, value)
      const updatedData = updateNestedValue(selectedReconciliationItem, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSaveReconciliationItem(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <ReconciliationItemBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedReconciliationItem={selectedReconciliationItem}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }